<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-person-stalker"></i>
        <div class="mg-l-20">
          <h4>{{ $t("router.原料供应商") }}</h4>
        </div>
      </div>
      <div class="tx-right">
        <a
          v-if="isSysRights('SupplierProductStock.createRawSupplier')"
          data-v-id="step2"
          href="javascript:;"
          class="btn btn-success mg-r-15"
          @click="addNew()"
          >{{ $t("distributor.新增供应商") }}</a
        >
        <a
          v-if="isSysRights('SupplierProductStock.batchCreateRawSupplier')"
          data-v-id="step5"
          href="javascript:;"
          class="btn btn-primary mg-r-15"
          @click="importyDistributor()"
          >{{ $t("distributor.导入供应商") }}</a
        >
        <a
          v-if="
            check_items.length > 0 &&
            isSysRights('SupplierProductStock.batchExportRawSupplier')
          "
          href="javascript:;"
          class="btn btn-primary mg-r-15"
          @click="exportDistributor('1')"
          >{{ $t("distributor.导出选中的客户") }}({{ check_items.length }})</a
        >
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-50"
    >
      <div class="clear-key">
        <a
          v-show="distributorName"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('name')"
        >
          {{ $t("distributor.客户名：") }}
          <span class="mg-r-10">{{ distributorName }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="batchBool"
          @click="clearKey('batchBool')"
          href="javascript:;"
          class="mg-r-15"
        >
          {{ $t("distributor.批量搜索") }}
          
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="cont"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('contact')"
        >
          {{ $t("distributor.联系人：") }}
          <span class="mg-r-10">{{ cont }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["check_items", "distributorName", "cont", "batchBool"],
  methods: {
    // 导出选中的客户
    exportDistributor() {
      this.$parent.loading = true;
      let url;
      if ($("#ifilePro").length == 0) {
        $("body").append(
          '<iframe id="ifilePro" style="display:none"></iframe>'
        );
      }
      let openDownload = (url) => {
        document.getElementById("ifilePro").src = url;
      };
      $.api_call(
        "api.SupplierProductStock.batchExportRawSupplier",
        {
          ids: this.check_items.join(","),
        },
        (r) => {
          this.$parent.loading = false;
          if (r.ErrorCode == "9999") {
            if (r.Data.Results.addTask) {
              this.$store.commit("addTaskTimeFn", moment().unix());
              return;
            }
            url = r.Data.Results.url;
            openDownload(url);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    // 导入客户
    importyDistributor() {
      this.$parent.modalImportOpen = Symbol();
      $("#modalImportDistributor").modal("show");
    },
    // 删除
    clearKey(type) {
      this.$emit("clearKey", type);
    },
    // 新增客户
    addNew() {
      this.$parent.modalDidtributor = JSON.parse(
        this.$parent.modalDidtributorDefault
      );
      this.$parent.modalDidtributor.open = Symbol();
      $("#modalDidtributor").modal("show");
    },
  },
};
</script>